
export const getSystemAlerts =  (resultAlerts : {data? : { Alert : {} }}) : any[] => {
  return Object.values(resultAlerts?.data?.Alert ?? {})
  .filter((alert : any) => {
    const val = JSON.parse(alert.value);
    return val && val["Firing"] && val["AlarmId"] !== 14;
  }) ?? [];
}